class PrelaunchPopup extends ModalDialog {
  constructor() {
    super();
    this.delay = parseInt(this.dataset.delay, 10) * 1000 || 0;
    this.sectionId = this.dataset.sectionId;
    this.storageKey = 'prelaunchPopupClosed';

    this.showPopupAfterDelay();
    this.initCtaLinks();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.show();
        }
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.hide();
        }
      });
    }
  }

  showPopupAfterDelay() {
    if (sessionStorage.getItem(this.storageKey)) {
      return;
    }

    setTimeout(() => {
      this.show();
    }, this.delay);
  }

  hide() {
    super.hide();
    sessionStorage.setItem(this.storageKey, '1');
  }

  initCtaLinks() {
    this.querySelectorAll('.prelaunch-modal__cta').forEach((link) => {
      link.addEventListener('click', () => {
        this.hide();
      });
    });
  }
}

customElements.define('prelaunch-popup', PrelaunchPopup);
